var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-footer',{staticClass:"mt-10",attrs:{"inset":"","dark":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('message.top.desc.footer'))),_c('br'),_vm._v(" © JAPAN PROFESSIONAL FOOTBALL LEAGUE J.LEAGUE,INC."),_c('br'),_vm._v(" ALL RIGHTS RESERVED. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }